var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89419 1.10529C4.97924 0.985453 5.08167 0.942932 5.2015 0.977722C5.32134 1.01251 5.38125 1.08209 5.38125 1.18646C5.38125 1.22125 5.38125 1.35655 5.38125 1.59235C5.38125 1.82815 5.38125 2.12193 5.38125 2.47369C5.38125 2.82546 5.38125 3.19849 5.38125 3.59277C5.38125 3.98319 5.38125 4.35429 5.38125 4.70605C5.38125 5.05782 5.38125 5.3516 5.38125 5.5874C5.38125 5.8232 5.38125 5.9585 5.38125 5.99329C5.38125 6.09766 5.42377 6.1943 5.50882 6.2832C5.59772 6.36825 5.6963 6.41077 5.80453 6.41077C5.85478 6.41077 5.95722 6.41077 6.11184 6.41077C6.26647 6.41077 6.43269 6.41077 6.6105 6.41077C6.78832 6.41077 6.94101 6.41077 7.06857 6.41077C7.2 6.41077 7.26571 6.41077 7.26571 6.41077C7.35849 6.41077 7.42227 6.45329 7.45706 6.53833C7.49185 6.62337 7.48219 6.70455 7.42807 6.78186L3.40402 12.1395C3.31898 12.2594 3.20881 12.2941 3.07351 12.2439C2.94208 12.1975 2.87637 12.1009 2.87637 11.954V7.45447C2.87637 7.31531 2.80679 7.24573 2.66763 7.24573H0.997708C0.904935 7.24573 0.83922 7.21094 0.800565 7.14136C0.765775 7.06791 0.775439 6.99253 0.829556 6.91522L4.89419 1.10529Z",
    fill: "#155DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickProcess);
export default __webpack_public_path__ + "static/media/quick_process.17c71456dcc3105edd0b69824b6a662a.svg";
export { ForwardRef as ReactComponent };